import { useEffect } from "react";
import * as Sentry from "@sentry/react";
import { useRouteError, isRouteErrorResponse } from "react-router-dom";

const NO_ERROR_DETAILS = "No error details available";
const UNKNOWN_ROUTE_ERROR = "Unknown route error";
const ERROR_TYPE = "route-error";

const RouteErrorBoundary: React.FC = () => {
  const routeError = useRouteError();

  useEffect(() => {
    if (routeError) {
      if (isRouteErrorResponse(routeError)) {
        Sentry.withScope((scope) => {
          scope.setTag("type", ERROR_TYPE);
          Sentry.captureException(
            new Error(routeError.statusText || UNKNOWN_ROUTE_ERROR),
          );
        });
      } else if (routeError instanceof Error) {
        Sentry.withScope((scope) => {
          scope.setTag("type", ERROR_TYPE);
          Sentry.captureException(routeError);
        });
      } else {
        Sentry.withScope((scope) => {
          scope.setTag("type", ERROR_TYPE);
          Sentry.captureException(new Error(String(routeError)));
        });
      }
    }
  }, [routeError]);

  const getErrorMessage = () => {
    if (!routeError) {
      return NO_ERROR_DETAILS;
    }
    if (isRouteErrorResponse(routeError)) {
      return routeError.statusText || UNKNOWN_ROUTE_ERROR;
    }
    if (routeError instanceof Error) {
      return routeError.message;
    }
    return String(routeError);
  };

  return (
    <div
      style={{
        backgroundColor: "#fff",
        color: "#fff",
        minHeight: "100vh",
        userSelect: "text",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: "20px",
      }}
    >
      <h1 style={{ margin: 0 }}>Ouch! Route error occurred.</h1>
      <p style={{ margin: "10px 0" }}>{getErrorMessage()}</p>
    </div>
  );
};

export default RouteErrorBoundary;
